import * as React from "react";
import { StyleSheet, StatusBar, TextInput } from "react-native";
import Colors from "../../constants/Colors";
import { View, Text } from "../../components/Themed";
import PageHeader from "../../components/PageHeader";
import { useEffect, useRef } from "react";
import { getLocalData } from "../../services/storage";
import Toast from "react-native-toast-message";

export const Unlock = ({ navigation, route }: any) => {
  const [count, setCount] = React.useState(0);
  const [input1Value, setInput1Value] = React.useState("");
  const input1 = useRef<TextInput>(null);
  const { propertyDetails } = route.params;

  useEffect(() => {
    input1.current?.focus();
  }, []);

  useEffect(() => {
    if (input1Value.length === 4) {
      checkPin();
    }
  }, [input1Value]);

  const checkPin = async () => {
    const pin = await getLocalData("@pin");
    if (pin) {
      if (input1Value === pin) {
        navigation.navigate("OpenHouseCheckIn", {
          unlock: false,
          openHouse: {
            propertyDetails,
          },
        });
      } else {
        setCount(count + 1);
        if (count >= 5) {
          setInput1Value("");
          Toast.show({
            type: "error",
            position: "top",
            text1: "Seems You Forgot Your Pin",
            text2: `Your pin is ${pin}`,
            visibilityTime: 5000,
          });
        } else {
          Toast.show({
            type: "error",
            position: "top",
            text1: "Incorrect Pin",
            text2: "Please try again",
            visibilityTime: 1800,
          });
          setInput1Value("");
          // input1?.current?.clear();
        }
      }
    }
  };

  const UnlockTextBoxContainer = (props: any) => (
    <View style={[styles.unlockContainer, styles.textContainer]}>
      {props.children}
    </View>
  );

  const TextBox1 = () => (
    <TextInput
      ref={input1}
      secureTextEntry
      keyboardType="number-pad"
      maxLength={4}
      // value={input1Value}
      onChangeText={(text) => setInput1Value(text)}
      style={styles.textbox}
    ></TextInput>
  );

  return (
    <View
      lightColor={Colors.base_colors_white}
      darkColor={Colors.nuetral_grey_600}
      style={styles.container}
    >
      <StatusBar hidden={true} />
      <PageHeader
        leftComponent={
          <Text
            size={18}
            lineHeight={24}
            weight="SemiBold"
            lightColor={Colors.nuetral_grey_700}
          >
            Unlock Sign In
          </Text>
        }
      />
      <View style={styles.unlockContainer}>
        <Text
          style={styles.instructions}
          size={20}
          lineHeight={28}
          lightColor={Colors.nuetral_grey_700}
        >
          Enter the pin you created when locking this form.
        </Text>
        <View style={[styles.unlockContainer, styles.textContainer]}>
          <TextInput
            ref={input1}
            secureTextEntry
            keyboardType="number-pad"
            maxLength={4}
            onChangeText={(text) => setInput1Value(text)}
            style={styles.textbox}
          ></TextInput>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  unlockContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "35%",
    alignSelf: "center",
    gap: 24,
    marginBottom: 150,
  },
  passwordContainer: {
    flexDirection: "row",
    gap: 16,
  },
  instructions: {
    textAlign: "center",
  },
  textbox: {
    borderBottomWidth: 1,
    width: 150,
    textAlign: "center",
  },
  textContainer: {
    flexDirection: "row",
    gap: 16,
  },
});
